export default __webpack_public_path__ + "static/media/bg-subscription-section.d49327d4.webp";